import React, { useState } from 'react';
import DropArea from './DropArea/DropArea';
import { MainContainer } from './Atom';
import { connect } from 'react-redux';
import { instructionVersionsDataChanged } from '../../actions/instuctionActions';
import deleteSection from '../DeleteSection';

function OKNOKDropField ({ dispatch, oknok, versionIndex, dataIndex, disable, lastUsedAttachment }) {
  const instructionVersionsData = (value, field) => {
    dispatch(instructionVersionsDataChanged(versionIndex, dataIndex, {
      ...oknok,
      [field]: value
    }));
  };
  const instructionVersionsDataObj = (obj) => { dispatch(instructionVersionsDataChanged(versionIndex, dataIndex, { ...oknok, ...obj }));};

  return (
    <MainContainer>
      <DropArea
        type="OK"
        attachment={oknok.attachments[0]}
        setAttachment={instructionVersionsDataObj}
        label={oknok.labelOK}
        setLabel={instructionVersionsData}
        description={oknok.descriptionOK}
        setDescription={instructionVersionsData}
        disable={disable}
        allAttachments={oknok.attachments}
        lastUsedAttachment={lastUsedAttachment}
      />
      <DropArea
        type="NOK"
        attachment={oknok.attachments[1]}
        setAttachment={instructionVersionsDataObj}
        label={oknok.labelNOK}
        setLabel={instructionVersionsData}
        description={oknok.descriptionNOK}
        setDescription={instructionVersionsData}
        disable={disable}
        allAttachments={oknok.attachments}
        lastUsedAttachment={lastUsedAttachment}
      />
    </MainContainer>
  );
}

function mapStateToProps ({ filesWidgetReducer, instructionsReducer }) {
  return {
    lastUsedAttachment: filesWidgetReducer.lastUsedAttachment,
    versions: instructionsReducer.versions
  };
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(deleteSection(OKNOKDropField));
